var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0998 6.16602C4.55341 6.16602 3.2998 7.41962 3.2998 8.96601V31.366C3.2998 32.9124 4.55341 34.166 6.0998 34.166H42.4998C44.0462 34.166 45.2998 32.9124 45.2998 31.366V8.96602C45.2998 7.41962 44.0462 6.16602 42.4998 6.16602H6.0998ZM32.6994 34.1661H15.8994C17.7358 34.1661 20.7767 36.575 22.6521 38.2329C23.6037 39.0741 25.0432 39.1303 26.0346 38.3365C28.1067 36.6774 31.4494 34.1661 32.6994 34.1661Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0103 22.966L14.6725 21.0256H18.5687L19.2155 22.966H21.4485L17.4445 12.0012H15.7659L11.7773 22.966H14.0103ZM17.9992 19.2237H15.2734L16.6594 15.2351L17.9992 19.2237ZM36.8998 13.166H24.2998V14.566H36.8998V13.166ZM36.8998 20.166H24.2998V21.566H36.8998V20.166ZM11.7002 27.166H36.9002V28.566H11.7002V27.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0996 38.9617C21.0331 39.643 21.9292 40.3936 22.6521 41.0327C23.6036 41.8739 25.0432 41.9301 26.0346 41.1363C28.0992 39.4831 31.4254 36.9839 32.6858 36.966H45.2998C46.8462 36.966 48.0998 35.7124 48.0998 34.166V24.366H51.4596C52.6967 24.366 53.6996 25.3688 53.6996 26.606V44.8586C53.6996 46.0958 52.6967 47.0986 51.4596 47.0986H22.3396C21.1025 47.0986 20.0996 46.0958 20.0996 44.8586V38.9617ZM30.1797 47.0987H43.6197C42.6221 47.0987 39.9587 49.1275 38.3002 50.4746C37.503 51.1221 36.3362 51.0768 35.5715 50.3912C34.0703 49.0455 31.6454 47.0987 30.1797 47.0987Z",
    fill: "#6B7CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon 5.89a372ab34bb5dbfde46ea7329dff16e.svg";
export { ForwardRef as ReactComponent };